<template lang="pug">
  .n-radio
    a.radio-option(
      v-for="(item, index) in items"
      :class="getRadioValue(item) === value ? 'selected' : ''"
      :key="index"
      @click="onSelectOption(item)"
    )
      span {{ getRadioText(item) }}

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class NRadio extends Vue {
  @Prop({ type: [ String, Number, Boolean ], default: 0 }) value
  @Prop({ type: Boolean, default: false }) readonly
  @Prop({ type: String, default: '' }) label
  @Prop({ type: String, default: 'text' }) textField
  @Prop({ type: String, default: 'value' }) valueField
  @Prop({
    type: Array,
    default: () => [
      {
        value: true,
        text: 'Ja'
      },
      {
        value: false,
        text: 'Nein'
      }
    ]
  }) items

  getRadioText (item) {
    return this.textField
      ? item[this.textField]
      : item
  }

  getRadioValue (item) {
    return this.valueField
      ? item[this.valueField]
      : item
  }

  onSelectOption (item) {
    if (this.readonly) {
      return
    }

    const value = this.getRadioValue(item)
    this.$emit('change', value)
    this.$emit('input', value)
  }
}
</script>
